import React from "react";
import Form from "./Components/Form";
import FormField from "./Components/FormField";
import Heading from "src/components/Heading";

const ContactForm = ({ props }) => {
  return (
    <Form name="contact" action="/contact-thank-you/">
      <div className="sm:col-span-2 text-center mb-6">
        <span className="block mb-3 font-bold">
          Who are you looking to support?
        </span>
        <div className="flex gap-x-5 justify-center">
          <FormField
            containerClass="flex items-center"
            id="workplace"
            label="Workplace"
            type="radio"
            value="Workplace"
          />
          <FormField
            containerClass="flex items-center"
            id="education"
            label="Education"
            type="radio"
            value="Education"
          />
          <FormField
            containerClass="flex items-center"
            id="sportsclubs"
            label="Sports &amp; Clubs"
            type="radio"
            value="Sports &amp; Clubs"
          />
          <FormField
            containerClass="flex items-center"
            id="myself"
            label="Myself"
            type="radio"
            value="Myself"
          />
        </div>
      </div>
      <FormField
        containerClass="sm:col-span-1"
        id="organisation-name"
        label="Organisation name"
        required
        type="text"
        autoComplete="org-name"
        placeholder="Organisation name"
      />
      <FormField
        containerClass="sm:col-span-1"
        id="full-name"
        label="Full name"
        required
        type="text"
        autoComplete="given-name"
        placeholder="Full name"
      />
      <FormField
        containerClass="sm:col-span-2"
        id="email"
        label="Email address"
        required
        type="email"
        autoComplete="email"
        placeholder="Email Address"
      />
      <FormField
        containerClass="sm:col-span-2"
        id="telephon"
        label="Phone"
        type="number"
        placeholder="Phone number"
      />
      <FormField
        containerClass="sm:col-span-2"
        id="message"
        label="How can we help you?"
        type="textarea"
        placeholder="Please type your message here..."
      />
    </Form>
  );
};

export default ContactForm;
